<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import HotelSearchForm from '~src/components/search/forms/hotelSearchForm.src'
    import {encodeSupplierCode, hotelNameToUrl} from '@/utils/helpers'

    @Component({mixins: [HotelSearchForm]})
    export class HotelInfoSearchForm extends Vue {
        async search() {
            this.$emit('close-popup')
            const query = this.newQuery()
            if (!query.hotelId) {
                Object.assign(query, hotelsRuntimeStore.hotelInfoRequest)
                if (query.supplierCode) query.supplierCode = encodeSupplierCode(query.supplierCode)
            } else {
                delete query.hotelCode
                delete query.supplierCode
                delete query.cityCode
            }
            try {
                await this.$router.push({name: 'hotel', params: {name: hotelNameToUrl(this.$route.params.name)}, query})
            } catch (e) {
                await hotelsRuntimeStore.singleHotelSearch(this.searchRequest)
            }
        }

        get isSingleHotelSearch() {
            return true
        }

        get searchRequest() {
            return hotelsStore.singleHotelSearchRequest
        }

        get searchRequestTourists() {
            return hotelsStore.singleHotelSearchRequestTourists
        }
    }

    export default {...toNative(HotelInfoSearchForm), ssrRender: HotelSearchForm.ssrRender}
</script>
